import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { ValidatedResponse } from '../../shared/models/validated-response.model';

@Injectable()
/**
 * Allows request of user's security transaction claims and identity information
*/
export class ClaimsService extends BaseApiService {
    /**
     * Get currently logged in user's security transactions
     */
    getSecurityClaims(): Observable<ValidatedResponse<any>> {
        return this.get('Foundation/User/Claims/');
    }

    /**
    * Get currently logged in user's ACS transactions
    */
    getACSClaims(): Observable<ValidatedResponse<any>> {
        return this.get('Foundation/User/ACSClaims/');
    }

    /**
     * Get currently logged in user's composite set of claims (All allowed claims - transactionClaims, ACSClaims, etc)
     */
    getMultipleClaims(): Observable<ValidatedResponse<any>> {
        return this.get('Foundation/User/MultipleClaims');
    }

    /**
     * Get currently logged in user's identity information
     */
    getUserIdentity(): Observable<ValidatedResponse<any>> {
        return this.get('Foundation/User/Identity/');
    }
}
